import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { c as _c } from "react-compiler-runtime";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ButtonStyled } from '@nike/nike-design-system-components';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import { CallToActionSection, CodeText, ReasonCopy } from './styles';
import FlexBox from "../../styles/components/FlexBox";
import useErrorModalStore from "../../store/error-modal/use-store";
import ErrorMessageProductInfo from "../error-message-product-info";
import MessageText from "../message-text";
import trackEvent from "../../analytics/track-event";
import getIsPageCart from "../../utils/get-is-page-cart";
var CallToAction = function CallToAction(t0) {
  var $ = _c(7);
  var onClose = t0.onClose;
  var t1;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = getIsPageCart();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  var isPageCart = t1;
  var t2;
  if ($[1] === Symbol["for"]("react.memo_cache_sentinel")) {
    t2 = {
      stringKey: "error.errorMessage.OK",
      primaryValue: "OK",
      description: "OK"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  var cartMessage = useI18nString(t2);
  var t3;
  if ($[2] === Symbol["for"]("react.memo_cache_sentinel")) {
    t3 = {
      stringKey: "error.errorMessage.viewCart",
      primaryValue: "View Cart",
      description: "View Cart"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  var genericMessage = useI18nString(t3);
  var t4;
  if ($[3] !== cartMessage || $[4] !== genericMessage || $[5] !== onClose) {
    var _window;
    t4 = isPageCart ? /*#__PURE__*/React.createElement(ButtonStyled, {
      id: "error-close",
      appearance: "primary",
      background: "light",
      size: "medium",
      type: "button",
      "data-automation": "error-close",
      onClick: onClose,
      ariaLabel: cartMessage
    }, cartMessage) : /*#__PURE__*/React.createElement(ButtonStyled, {
      id: "error-close",
      appearance: "primary",
      background: "light",
      size: "medium",
      type: "button",
      Component: "a",
      href: (_window = window) === null || _window === void 0 || (_window = _window.NikeShop) === null || _window === void 0 || (_window = _window.get()) === null || _window === void 0 ? void 0 : _window.cartHref,
      componentType: ButtonStyled,
      "data-automation": "error-view-cart",
      ariaLabel: genericMessage
    }, genericMessage);
    $[3] = cartMessage;
    $[4] = genericMessage;
    $[5] = onClose;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
CallToAction.propTypes = {
  onClose: PropTypes.func
};
var Message = function Message() {
  var $ = _c(11);
  var _useErrorModalStore = useErrorModalStore(_temp),
    error_0 = _useErrorModalStore.error,
    clearError_0 = _useErrorModalStore.clearError;
  var _ref = error_0 || {},
    crcCode = _ref.crcCode,
    servicePath = _ref.servicePath,
    message = _ref.message,
    reasons = _ref.reasons;
  useEffect(function () {
    if (crcCode) {
      trackEvent("Error Modal Viewed", {
        errorCode: crcCode,
        servicePath: servicePath,
        message: message
      });
    }
  }, [crcCode, servicePath, message]);
  var reasonCodes = reasons === null || reasons === void 0 ? void 0 : reasons.map(_temp2);
  var uniqueReasonCodes = _toConsumableArray(new Set(reasonCodes));
  var t0;
  if ($[0] !== crcCode) {
    t0 = /*#__PURE__*/React.createElement(ErrorMessageProductInfo, {
      crcCode: crcCode
    });
    $[0] = crcCode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  var t1 = uniqueReasonCodes === null || uniqueReasonCodes === void 0 ? void 0 : uniqueReasonCodes.map(_temp3);
  var t2;
  if ($[2] !== crcCode) {
    t2 = crcCode ? /*#__PURE__*/React.createElement(MessageText, null, /*#__PURE__*/React.createElement(CodeText, {
      "aria-hidden": "true"
    }, "[ Code: ".concat(crcCode, " ]"))) : null;
    $[2] = crcCode;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  var t3;
  if ($[4] !== clearError_0) {
    t3 = clearError_0 ? /*#__PURE__*/React.createElement(CallToActionSection, null, /*#__PURE__*/React.createElement(CallToAction, {
      onClose: clearError_0
    })) : null;
    $[4] = clearError_0;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  var t4;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = /*#__PURE__*/React.createElement(FlexBox, {
      flexDirection: "column",
      id: "error-message-container",
      "data-automation": "error-message-container"
    }, t0, t1, t2, t3);
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
Message.propTypes = {
  onClose: PropTypes.func,
  crcCode: PropTypes.string,
  servicePath: PropTypes.string,
  message: PropTypes.string,
  reasons: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.string
  }))
};
export default Message;
function _temp(t0) {
  var error = t0.error,
    clearError = t0.clearError;
  return {
    error: error,
    clearError: clearError
  };
}
function _temp2(t0) {
  var code = t0.code;
  return code;
}
function _temp3(reasonCode) {
  return /*#__PURE__*/React.createElement(ReasonCopy, {
    key: "reason-code-key-".concat(reasonCode)
  }, reasonCode);
}